import { render } from "./RecommendedSessions.vue?vue&type=template&id=983492e4"
import script from "./RecommendedSessions.vue?vue&type=script&lang=js"
export * from "./RecommendedSessions.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__